import HeartFilled from '../../src/legacy/HeartFilled';
export default HeartFilled;
